import { render, staticRenderFns } from "./suivi_commandes.vue?vue&type=template&id=669bd26e&"
import script from "./suivi_commandes.vue?vue&type=script&lang=js&"
export * from "./suivi_commandes.vue?vue&type=script&lang=js&"
import style0 from "./suivi_commandes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports